export const PERMISSION_ROLE_MANAGE = 'soa:role:manage';
export const PERMISSION_AUDIT_READ = 'soa:audit:read';
